import { Product } from '../model/product';
import { ProductApiService } from './product-api.service';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { ProductActions } from '../store/product.actions';
import { Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductFacadeService {
  private productApiService = inject(ProductApiService);
  private store = inject(Store);

  public getList(): Observable<Product[]> {
    return this.productApiService.getList().pipe(
      catchError(error => {
        console.error('Product API error:', error);
        return throwError(() => error);
      })
    );
  }

  public getByApiName(apiName: string): Observable<Product> {
    return this.productApiService.getByApiName(apiName).pipe(
      tap(product => {
        this.store.dispatch(new ProductActions.SetSelectedProduct(product));
      }),
      catchError(error => {
        console.error('Product API error:', error);
        return throwError(() => error);
      })
    );
  }
}
